<template>
    <div class="RwvContentMarkdownToggle">
      <b-form-group
        :id="'input-group-title-' + index"
        :label-for="'input-title-' + index"
        v-b-tooltip.hover
        title="Titel des Buttons zum Aufklappen">

        <b-form-input
          :id="'input-title-' + index"
          v-model="data.title"
          required
          placeholder="Titel">
        </b-form-input>
      </b-form-group>

      <b-form-group
        :id="'input-group-variant-' + index"
        :label-for="'input-variant-' + index"
        v-b-tooltip.hover
        title="Aussehen des Buttons zum Aufklappen">

        <b-form-input
          :id="'input-variant-' + index"
          v-model="data.variant"
          required
          placeholder="Variante">
        </b-form-input>

        <p class="text-muted small">
          Mögliche Varianten: <code>primary</code>, <code>secondary</code> <br>
          Mit dem Prefix <code>outline-</code> wird der button nicht ausgefüllt. <br>
          Weitere Varianten finden sich
          <a href='https://bootstrap-vue.js.org/docs/components/button#contextual-variants' target='_blank'>hier</a>
        </p>
      </b-form-group>

      <RwvContentMarkdownEdit
        :markdown="data.markdown"
        :index="index"
        @changed="dataChanged">
      </RwvContentMarkdownEdit>
    </div>
</template>

<script>
import RwvContentMarkdownEdit from "@/components/Contents/Markdown/ContentMarkdownEdit";

export default {
  name:"RwvContentMarkdownToggle",
  props: {
    data: {
      type: Object,
      required: true
    },
    index: {
      type: Number,
      required: true
    }
  },
  components: {
    RwvContentMarkdownEdit
  },
  watch: {
    data(data) {
      this.$emit("changed", data)
    }
  },
  methods: {
    dataChanged(data) {
      this.data.markdown = data
    }
  }
}
</script>
